import React from 'react';

interface ProgressBarProps {
  label: string;
  value: number;
  maxValue?: number;
  color?: string;
  showPercentage?: boolean;
  showValue?: boolean;
  trend?: number;
  size?: 'sm' | 'md' | 'lg';
}

export default function ProgressBar({
  label,
  value,
  maxValue = 100,
  color = 'bg-blue-500',
  showPercentage = true,
  showValue = false,
  trend,
  size = 'md',
}: ProgressBarProps) {
  const percentage = Math.min(Math.max((value / maxValue) * 100, 0), 100);

  const sizeClasses = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3',
  };

  const trendColor = trend && trend > 0 ? 'text-green-600' : trend && trend < 0 ? 'text-red-600' : '';

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <div className="flex items-center gap-2">
          {showValue && (
            <span className="text-sm text-gray-600">
              {value}{maxValue !== 100 && `/${maxValue}`}
            </span>
          )}
          {showPercentage && (
            <span className="text-sm font-semibold text-gray-900">{percentage.toFixed(0)}%</span>
          )}
          {trend !== undefined && (
            <span className={`text-xs font-medium ${trendColor}`}>
              {trend > 0 && '+'}
              {trend}%
            </span>
          )}
        </div>
      </div>
      <div className={`w-full bg-gray-200 rounded-full ${sizeClasses[size]}`}>
        <div
          className={`${color} ${sizeClasses[size]} rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
